module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL TOPOGRAPHIC SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.qaqcEnabled) ? _c('label', [_c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingTopographyList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('checkBoxPanel', {
    ref: "topoSettingCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.topographicSettingList,
      "fieldName": 'topographicSettingId',
      "name": _vm.qaqcFieldId + 'siteSettingTopoCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Geographic Division")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.qaqcEnabled) ? _c('label', [_c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingDivisionList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('checkBoxPanel', {
    ref: "divisionCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.geographicDivisionList,
      "fieldName": 'geographicDivisionId',
      "name": _vm.qaqcFieldId + 'siteSettingDivisionCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("UNIQUE SITE SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingUniqueSettingList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('checkBoxPanel', {
    ref: "uniqueSettingCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.uniqueSettingList,
      "fieldName": 'uniqueSettingId',
      "name": _vm.qaqcFieldId + 'siteSettingUniqueCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("BARE GROUND PERCENTAGE")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteSetting.percentBareGround),
      expression: "siteSetting.percentBareGround"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.siteSetting.percentBareGround)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteSetting, "percentBareGround", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'percentBareGround',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL TOPOGRAPHIC SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(1), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'generalTopographicSetting',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteSetting.generalTopographicSetting),
      expression: "siteSetting.generalTopographicSetting"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.siteSetting.generalTopographicSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteSetting, "generalTopographicSetting", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("VEGETATION ASSOCIATION")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.qaqcEnabled) ? _c('label', [_c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingVegetationList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('checkBoxPanel', {
    ref: "vegetationCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.vegetationTypeList,
      "fieldName": 'vegetationTypeId',
      "name": _vm.qaqcFieldId + 'siteSettingVegetationCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL DEPOSITIONAL ENVIRONMENT")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingDepositionalTypeList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('checkBoxPanel', {
    ref: "depositionalCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.depositionalTypeList,
      "fieldName": 'depositionalTypeId',
      "name": _vm.qaqcFieldId + 'siteSettingGeneralDepositionCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("AEOLIAN SETTINGS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteSetting.aeolianSettingsId),
      expression: "siteSetting.aeolianSettingsId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteSetting, "aeolianSettingsId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Unknown")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Not Applicable")])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'aeolianSettingsId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteSetting.aeolianSettingsId == 1),
      expression: "siteSetting.aeolianSettingsId == 1"
    }],
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(4), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingAeolianTypeList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('checkBoxPanel', {
    ref: "aeolianCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.aeolianTypeList,
      "fieldName": 'aeolianTypeId',
      "name": _vm.qaqcFieldId + 'siteSettingAeolianCB'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("SUBSURFACE POTENTIAL")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteSetting.subsurfacePotentialId),
      expression: "siteSetting.subsurfacePotentialId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteSetting, "subsurfacePotentialId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Unknown")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Not Applicable")])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'subsurfacePotentialId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteSetting.subsurfacePotentialId == 1),
      expression: "siteSetting.subsurfacePotentialId == 1"
    }],
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(6), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteSettingDepositEstimateBasisList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('checkBoxPanel', {
    ref: "estimateCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.depositEstimateBasisList,
      "fieldName": 'depositEstimateBasisId',
      "name": _vm.qaqcFieldId + 'siteSettingDepoEstimateCB'
    }
  })], 1)]), _vm._v(" "), (!(_vm.qaqcEnabled || _vm.formDisabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveSiteSetting
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'siteSetting',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Check as appropriate, describe site setting in general narrative")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Few words")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Check as appropriate, describe site setting in general narrative")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Late Pleistocene and Holocene aeolian deposits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Type(s) of aeolian setting(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Archaeological subsurface deposits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Estimate based on")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88d4ede0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/SiteSettingForm.vue
// module id = 972
// module chunks = 1